import Vue from 'vue'
import workorders from '../../api/workorders'

// initial state
const state = {
  workorders: {root: [], totalCount: 0},
  saveWorkOrderResponse: false,
  deleteWorkOrderResponse: false
}

// getters
const getters = {
  workorders: state => state.workorders,
  saveWorkOrderResponse: state => state.saveWorkOrderResponse,
  deleteWorkOrderResponse: state => state.deleteWorkOrderResponse
}

// actions
const actions = {
  getWorkOrders: function (context, data) {
    workorders.getWorkOrders(data, workorders => {
      context.commit('RECEIVE_WORK_ORDERS', { workorders })
    })
  },
  saveWorkOrder: function (context, data) {
    workorders.saveWorkOrder(data, saveWorkOrderResponse => {
      context.commit('SAVE_WORK_ORDER_RESPONSE', { saveWorkOrderResponse })
    })
  },
  deleteWorkOrder: function (context, data) {
    workorders.deleteWorkOrder(data, deleteWorkOrderResponse => {
      context.commit('DELETE_WORK_ORDER_RESPONSE', { deleteWorkOrderResponse })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_WORK_ORDERS'] (state, { workorders }) {
    workorders.totalCount = parseInt(workorders.totalCount)
    state.workorders = workorders
  },
  ['SAVE_WORK_ORDER_RESPONSE'] (state, { saveWorkOrderResponse }) {
    state.saveWorkOrderResponse = saveWorkOrderResponse
  },
  ['DELETE_WORK_ORDER_RESPONSE'] (state, { deleteWorkOrderResponse }) {
    if(deleteWorkOrderResponse.error == true) Vue.$notify.error(deleteWorkOrderResponse.notice);
    else Vue.$notify.success(deleteWorkOrderResponse.notice);
    state.deleteWorkOrderResponse = deleteWorkOrderResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorders.js